import { InvoiceFilter, SearchRequestInput } from 'common/types/globalTypes';

import { TABLE_ROWS } from 'common/constants';
import {
  getFilterParams,
  toFilterVariable,
  toOrderByVariable,
} from 'ap/signing/utils.common';
import { SortOrder } from 'common/utils/commonTypes';
import { FilterArrayType } from 'common/components/Filters';
import { InvoiceSigningSearchHintsVariables } from 'ap/signing/__generated__/InvoiceSigningSearchHints';
import { InvoiceSigningSearchFilterTotalsVariables } from 'ap/signing/__generated__/InvoiceSigningSearchFilterTotals';
import {
  InvoicesSigningSearch,
  InvoicesSigningSearchVariables,
} from 'common/components/Modules/TransactionEdit/graphql/__generated__/InvoicesSigningSearch';

export const handleSearchGlobal = async (
  filterSupplierId: string | undefined,
  showMore: boolean,
  // newHints: boolean,
  globalValue: boolean,
  searchTextValue: string | null,
  searchHints: number | null | undefined,
  invoicesData: InvoicesSigningSearch | undefined,
  sortOrderParam: SortOrder | undefined,
  searchFilters: FilterArrayType[],
  isSearchAllData: boolean,
  isSigningSearch: boolean,
  isHistorySearch: boolean
) => {
  const SearchFiltersUpdated = searchFilters.filter(
    (f) => f.filterKey !== 'filterMultiStatusTypes'
  );
  const filterMultiStatusTypes = searchFilters.find(
    (f) => f.filterKey === 'filterMultiStatusTypes'
  )?.value as number[];
  const filterParams = getFilterParams(searchFilters);
  const searchRequest = searchTextValue
    ? {
        searchText: [searchTextValue ? searchTextValue : ''],
        searchHintId: searchHints,
      }
    : undefined;
  const searchHintsRequest: SearchRequestInput = {
    searchText: [searchTextValue ? searchTextValue : ''],
    searchHintId: null,
  };
  const searchQueryParam =
    searchTextValue && searchTextValue.length > 0 ? searchTextValue : undefined;
  const variables: InvoicesSigningSearchVariables = {
    isSigningSearch,
    isHistorySearch,
    first: TABLE_ROWS,
    after: showMore
      ? invoicesData?.invoiceSigningSearch?.pageInfo.endCursor
      : undefined,
    orderBy: toOrderByVariable(sortOrderParam),
    filter: SearchFiltersUpdated?.length
      ? ({ and: toFilterVariable(SearchFiltersUpdated) } as InvoiceFilter)
      : undefined,
    invoiceSigningSearchSearchRequest: searchRequest,
    isLinkSearch: globalValue,
    isSearchAllData: isSearchAllData,
    filterMultiStatusTypes,
    filterSupplierId,
  };

  const totalFilterVariables: InvoiceSigningSearchFilterTotalsVariables = {
    isSigningSearch,
    isHistorySearch,
    invoiceSigningSearchSearchRequest: searchRequest,
    isLinkSearch: globalValue,
    isSearchAllData,
    ...filterParams,
    filterSupplierId,
  };

  const variableHints: InvoiceSigningSearchHintsVariables = {
    invoiceSigningSearchRequest: searchHintsRequest,
    isLinkSearch: globalValue,
    isSearchAllData,
    filterMultiStatusTypes,
    filterSupplierId,
  };

  return {
    searchQueryParam,
    searchRequest,
    queryVariables: variables,
    queryTotalFilterVariables: totalFilterVariables,
    variableHints,
  };
};
